import { CarvanaTheme } from '@carvana/showroom-theme';
import styled from 'styled-components';

export const ResultsSection = styled.div.attrs({
  className: 'gap-16 grid m:gap-x-[48px] m:gap-y-16 l:gap-x-16',
  'data-qa': 'results-section'
})`
  grid-template-columns: minmax(0, 1fr);
  @media (min-width: ${CarvanaTheme.breakpoint.md}px) {
    grid-template-columns: repeat(2, minmax(320px, 1fr));
  }
  @media (min-width: ${CarvanaTheme.breakpoint.xl}px) {
    grid-template-columns: repeat(3, minmax(290px, 1fr));
  }
  @media (min-width: 1700px) {
    grid-template-columns: repeat(4, minmax(290px, 1fr));
  }
`;
